import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Employee } from "@/features/modules/employee/objects/Employee";
import { employeeModel } from "../EmployeeModel";

export const getEmployeeByBadgeNumber = async (badgeNumber: number): Promise<Employee | undefined> => {
  try {
    const snapshotQuery: Query<Employee> = query(
      employeeModel.getPathReference().withConverter(employeeModel.firestoreConverter),
      where("badgeNumber", "==", badgeNumber)
    );

    const snapshot: QuerySnapshot<Employee> = await getDocs(employeeModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return undefined;

    return snapshot.docs[0].data();
  } catch (error: unknown) {
    appFaultModel.catchAppError("EmployeeModel.getEmployeeByBadgeNumber", { badgeNumber }, error);
    return undefined;
  }
};
